module.exports = __webpack_public_path__ + "static/Browser-7426d537fc5681374d81bb7ba48573d7.png";